import { useMediaQuery, useTheme } from '@mui/material';

/**
 * The one definition of the phone / tablet layout: below the theme's `md`
 * breakpoint (900px). Desktop (900px and up) keeps today's layout.
 *
 * `noSsr` reads the media query on the first render, so a page never paints
 * the desktop layout for one frame before switching. jsdom has no
 * matchMedia, so tests render desktop unless they mock it.
 */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
};

export default useIsMobile;
